import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "tui-search-result-main"
};
var _hoisted_2 = {
  class: "tui-search-result-list"
};
var _hoisted_3 = {
  key: 0,
  class: "header"
};
var _hoisted_4 = {
  class: "list"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "more-text"
};
var _hoisted_7 = {
  key: 1,
  class: "tui-search-message-header"
};
var _hoisted_8 = {
  class: "header-content"
};
var _hoisted_9 = {
  class: "header-content-count normal"
};
var _hoisted_10 = {
  class: "header-content-keyword"
};
var _hoisted_11 = {
  class: "highlight"
};
var _hoisted_12 = {
  class: "header-content-type normal"
};
var _hoisted_13 = {
  key: 2,
  class: "tui-search-message-list"
};
var _hoisted_14 = {
  class: /*@__PURE__*/_normalizeClass(['list-group-date'])
};
var _hoisted_15 = {
  class: "more-text"
};
import { ref, watch, computed, onMounted, onUnmounted } from '../../../adapter-vue';
import { TUITranslateService, TUIConversationService, TUIStore, StoreName } from '@tencentcloud/chat-uikit-engine';
import { TUIGlobal } from '@tencentcloud/universal-api';
import SearchResultItem from './search-result-item/index.vue';
import SearchResultDefault from './search-result-default/index.vue';
import SearchResultLoading from './search-result-loading/index.vue';
import { searchMessageTypeList, searchMessageTypeDefault } from '../search-type-list';
import Icon from '../../common/Icon.vue';
import searchIcon from '../../../assets/icon/search.svg';
import enterIcon from '../../../assets/icon/right-icon.svg';
import { searchCloudMessages, enterConversation, generateSearchResultYMD, debounce } from '../utils';
import { enableSampleTaskStatus } from '../../../utils/enableSampleTaskStatus';
import { isPC, isUniFrameWork } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    searchType: {
      type: String,
      default: 'global',
      validator(value) {
        return ['global', 'conversation'].includes(value);
      }
    }
  },
  setup(__props) {
    var _searchMessageTypeDef, _searchMessageTypeDef2;
    var props = __props;
    // search params
    var keywordList = ref([]);
    var messageTypeList = ref((_searchMessageTypeDef = searchMessageTypeDefault[props.searchType]) === null || _searchMessageTypeDef === void 0 ? void 0 : _searchMessageTypeDef.value);
    var timePosition = ref(0);
    var timePeriod = ref(0);
    // 通过空格分割整串输入后，按照“与”关系搜索
    // 比如: 输入"111 222", 搜索既有 111 又有 222 的消息, 同时也包含到严格搜索“111 222”的消息情况
    var keywordListMatchType = ref('and');
    // current search tab key
    var currentSearchTabKey = ref((_searchMessageTypeDef2 = searchMessageTypeDefault[props.searchType]) === null || _searchMessageTypeDef2 === void 0 ? void 0 : _searchMessageTypeDef2.key);
    // search results all（所有会话搜索结果)
    var searchResult = ref({});
    var searchAllMessageList = ref([]);
    var searchAllMessageTotalCount = ref(0);
    // search results detail（具体某个会话的搜索结果）
    var currentSearchConversationID = ref('');
    var searchConversationResult = ref();
    var searchConversationMessageList = ref([]);
    var searchConversationMessageTotalCount = ref();
    // 文件消息/图片视频消息的搜索结果，按时间线分组
    var searchConversationResultGroupByDate = ref([]);
    // ui display control
    var isResultDetailShow = ref(false);
    var isLoading = ref(false);
    var isSearchDetailLoading = ref(false);
    var isSearchDefaultShow = computed(() => {
      if (isLoading.value) {
        return false;
      }
      if (props.searchType === 'global') {
        var _keywordList$value, _Object$keys;
        // 未搜索 / 有结果
        if (!(keywordList !== null && keywordList !== void 0 && (_keywordList$value = keywordList.value) !== null && _keywordList$value !== void 0 && _keywordList$value.length) || Object !== null && Object !== void 0 && (_Object$keys = Object.keys(searchResult.value)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
          return false;
        } else {
          return true;
        }
      } else {
        var _searchConversationMe;
        if (searchConversationMessageList !== null && searchConversationMessageList !== void 0 && (_searchConversationMe = searchConversationMessageList.value) !== null && _searchConversationMe !== void 0 && _searchConversationMe.length) {
          return false;
        } else {
          return true;
        }
      }
    });
    function onCurrentConversationIDUpdate(id) {
      props.searchType === 'conversation' && (currentSearchConversationID.value = id);
    }
    function onCurrentSearchInputValueUpdate(obj) {
      if ((obj === null || obj === void 0 ? void 0 : obj.searchType) === (props === null || props === void 0 ? void 0 : props.searchType)) {
        // 根据空格模糊搜索结果
        keywordList.value = obj !== null && obj !== void 0 && obj.value ? obj.value.trim().split(/\s+/) : [];
      }
    }
    function onCurrentSearchMessageTypeUpdate(typeObject) {
      if ((typeObject === null || typeObject === void 0 ? void 0 : typeObject.searchType) === (props === null || props === void 0 ? void 0 : props.searchType)) {
        var _typeObject$value, _searchMessageTypeDef3, _typeObject$value2, _searchMessageTypeDef4;
        currentSearchTabKey.value = (typeObject === null || typeObject === void 0 || (_typeObject$value = typeObject.value) === null || _typeObject$value === void 0 ? void 0 : _typeObject$value.key) || ((_searchMessageTypeDef3 = searchMessageTypeDefault[props.searchType]) === null || _searchMessageTypeDef3 === void 0 ? void 0 : _searchMessageTypeDef3.key);
        messageTypeList.value = (typeObject === null || typeObject === void 0 || (_typeObject$value2 = typeObject.value) === null || _typeObject$value2 === void 0 ? void 0 : _typeObject$value2.value) || ((_searchMessageTypeDef4 = searchMessageTypeDefault[props.searchType]) === null || _searchMessageTypeDef4 === void 0 ? void 0 : _searchMessageTypeDef4.value);
      }
    }
    function onCurrentSearchMessageTimeUpdate(timeObject) {
      if ((timeObject === null || timeObject === void 0 ? void 0 : timeObject.searchType) === (props === null || props === void 0 ? void 0 : props.searchType)) {
        var _timeObject$value, _timeObject$value2;
        timePosition.value = timeObject === null || timeObject === void 0 || (_timeObject$value = timeObject.value) === null || _timeObject$value === void 0 || (_timeObject$value = _timeObject$value.value) === null || _timeObject$value === void 0 ? void 0 : _timeObject$value.timePosition;
        timePeriod.value = timeObject === null || timeObject === void 0 || (_timeObject$value2 = timeObject.value) === null || _timeObject$value2 === void 0 || (_timeObject$value2 = _timeObject$value2.value) === null || _timeObject$value2 === void 0 ? void 0 : _timeObject$value2.timePeriod;
      }
    }
    onMounted(() => {
      TUIStore.watch(StoreName.CONV, {
        currentConversationID: onCurrentConversationIDUpdate
      });
      TUIStore.watch(StoreName.SEARCH, {
        currentSearchInputValue: onCurrentSearchInputValueUpdate,
        currentSearchMessageType: onCurrentSearchMessageTypeUpdate,
        currentSearchMessageTime: onCurrentSearchMessageTimeUpdate
      });
    });
    onUnmounted(() => {
      TUIStore.unwatch(StoreName.CONV, {
        currentConversationID: onCurrentConversationIDUpdate
      });
      TUIStore.unwatch(StoreName.SEARCH, {
        currentSearchInputValue: onCurrentSearchInputValueUpdate,
        currentSearchMessageType: onCurrentSearchMessageTypeUpdate,
        currentSearchMessageTime: onCurrentSearchMessageTimeUpdate
      });
    });
    var setMessageSearchResultList = option => {
      var _keywordList$value2;
      searchCloudMessages({
        keywordList: keywordList !== null && keywordList !== void 0 && (_keywordList$value2 = keywordList.value) !== null && _keywordList$value2 !== void 0 && _keywordList$value2.length ? keywordList.value : undefined,
        messageTypeList: typeof messageTypeList.value === 'string' ? [messageTypeList.value] : messageTypeList.value,
        timePosition: timePosition.value,
        timePeriod: timePeriod.value,
        conversationID: (option === null || option === void 0 ? void 0 : option.conversationID) || undefined,
        cursor: (option === null || option === void 0 ? void 0 : option.cursor) || undefined,
        keywordListMatchType: keywordListMatchType.value
      }).then(res => {
        enableSampleTaskStatus('searchCloudMessage');
        if (!(option !== null && option !== void 0 && option.conversationID)) {
          var _res$data, _res$data2, _searchAllMessageList;
          // 全部会话搜索结果
          option !== null && option !== void 0 && option.cursor ? searchAllMessageList.value = [...searchAllMessageList.value, ...res.data.searchResultList] : searchAllMessageList.value = res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.searchResultList;
          searchAllMessageTotalCount.value = res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.totalCount;
          var key = currentSearchTabKey.value === 'all' ? 'allMessage' : currentSearchTabKey.value;
          if (searchAllMessageList !== null && searchAllMessageList !== void 0 && (_searchAllMessageList = searchAllMessageList.value) !== null && _searchAllMessageList !== void 0 && _searchAllMessageList.length && currentSearchTabKey.value !== 'contact' && currentSearchTabKey.value !== 'group') {
            var _searchAllMessageList2, _res$data3;
            searchResult.value = Object.assign({}, searchResult.value, {
              [key]: {
                key,
                label: searchMessageTypeList[key].label,
                list: currentSearchTabKey.value === 'all' ? searchAllMessageList === null || searchAllMessageList === void 0 || (_searchAllMessageList2 = searchAllMessageList.value) === null || _searchAllMessageList2 === void 0 ? void 0 : _searchAllMessageList2.slice(0, 3) : searchAllMessageList === null || searchAllMessageList === void 0 ? void 0 : searchAllMessageList.value,
                cursor: (res === null || res === void 0 || (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.cursor) || null
              }
            });
          } else {
            searchResult === null || searchResult === void 0 || delete searchResult.value[key];
          }
        } else {
          var _res$data4, _res$data5, _res$data6;
          // 指定会话搜索结果
          searchConversationResult.value = res === null || res === void 0 ? void 0 : res.data;
          option !== null && option !== void 0 && option.cursor ? searchConversationMessageList.value = [...searchConversationMessageList.value, ...(res === null || res === void 0 || (_res$data4 = res.data) === null || _res$data4 === void 0 || (_res$data4 = _res$data4.searchResultList[0]) === null || _res$data4 === void 0 ? void 0 : _res$data4.messageList)] : searchConversationMessageList.value = res === null || res === void 0 || (_res$data5 = res.data) === null || _res$data5 === void 0 || (_res$data5 = _res$data5.searchResultList[0]) === null || _res$data5 === void 0 ? void 0 : _res$data5.messageList;
          // todo: 此处为 后台 totalCount 不准确的规避方案，待后台修复后请改为 res?.data?.totalCount
          searchConversationMessageTotalCount.value = res === null || res === void 0 || (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.totalCount;
          // 计算时间戳展示位置（仅会话内搜索 文件/图片 类型需要）
          if ((props === null || props === void 0 ? void 0 : props.searchType) === 'conversation' && (currentSearchTabKey.value === 'fileMessage' || currentSearchTabKey.value === 'imageMessage')) {
            searchConversationResultGroupByDate.value = groupResultListByDate(searchConversationMessageList.value);
          } else {
            searchConversationResultGroupByDate.value = [];
          }
        }
        isLoading.value = false;
        isSearchDetailLoading.value = false;
      });
    };
    var setMessageSearchResultListDebounce = debounce(setMessageSearchResultList, 500);
    var resetSearchResult = () => {
      searchResult.value = {};
      searchConversationResult.value = {};
      searchConversationMessageList.value = [];
      searchConversationResultGroupByDate.value = [];
    };
    watch(() => [keywordList.value, currentSearchTabKey.value, timePosition.value, timePeriod.value], (newValue, oldValue) => {
      var _keywordList$value3;
      if (newValue === oldValue) {
        return;
      }
      // 全局搜索必须有关键词，会话内搜索可以没有关键词
      if (!(keywordList !== null && keywordList !== void 0 && (_keywordList$value3 = keywordList.value) !== null && _keywordList$value3 !== void 0 && _keywordList$value3.length) && (props === null || props === void 0 ? void 0 : props.searchType) === 'global') {
        resetSearchResult();
        return;
      }
      isLoading.value = true;
      if (props.searchType === 'conversation') {
        // 会话内搜索
        resetSearchResult();
        setMessageSearchResultList({
          conversationID: currentSearchConversationID.value
        });
      } else {
        // 全局搜索
        if (oldValue && oldValue[1] === 'all' && newValue && newValue[1] === 'allMessage') {
          var _searchResult$value$a, _Object$keys2;
          // 从【全部结果-聊天记录】分类中 点击某条结果，直接跳转到【聊天记录】tab，并且打开相关会话内搜索结果 情况, isResultDetailShow 保持为true
          // 不重新搜索
          (searchResult === null || searchResult === void 0 || (_searchResult$value$a = searchResult.value.allMessage) === null || _searchResult$value$a === void 0 ? void 0 : _searchResult$value$a.list) && (searchResult.value.allMessage.list = searchAllMessageList === null || searchAllMessageList === void 0 ? void 0 : searchAllMessageList.value);
          // 清除非聊天记录类型的其他搜索结果
          Object === null || Object === void 0 || (_Object$keys2 = Object.keys(searchResult === null || searchResult === void 0 ? void 0 : searchResult.value)) === null || _Object$keys2 === void 0 || _Object$keys2.forEach(key => {
            if (key !== 'allMessage') {
              searchResult === null || searchResult === void 0 || delete searchResult.value[key];
            }
          });
          isLoading.value = false;
          return;
        } else {
          // 其余情况，恢复 isResultDetailShow.value 为 false，并且重新搜索
          isResultDetailShow.value = false;
          resetSearchResult();
        }
        setMessageSearchResultListDebounce();
      }
    }, {
      immediate: true
    });
    var getMoreResult = result => {
      if (currentSearchTabKey.value === 'all') {
        // 此时查看更多：切换到相应结果对应的result，展示其类型全量搜索结果
        TUIStore.update(StoreName.SEARCH, 'currentSearchMessageType', {
          value: searchMessageTypeList[result.key],
          searchType: props.searchType
        });
      } else {
        // 在某一单类结果下查看更多：根据 cursor 作为搜索起始位置，拉取下一部分结果
        setMessageSearchResultList({
          cursor: (result === null || result === void 0 ? void 0 : result.cursor) || undefined
        });
      }
    };
    var getMoreResultInConversation = () => {
      var _searchConversationRe;
      setMessageSearchResultList({
        cursor: searchConversationResult === null || searchConversationResult === void 0 || (_searchConversationRe = searchConversationResult.value) === null || _searchConversationRe === void 0 ? void 0 : _searchConversationRe.cursor,
        conversationID: currentSearchConversationID === null || currentSearchConversationID === void 0 ? void 0 : currentSearchConversationID.value
      });
    };
    var showResultDetail = (isShow, targetType, targetResult) => {
      var _targetResult$convers;
      isResultDetailShow.value = isShow;
      if (targetType) {
        TUIStore.update(StoreName.SEARCH, 'currentSearchMessageType', {
          value: searchMessageTypeList[targetType],
          searchType: props.searchType
        });
      }
      currentSearchConversationID.value = (targetResult === null || targetResult === void 0 || (_targetResult$convers = targetResult.conversation) === null || _targetResult$convers === void 0 ? void 0 : _targetResult$convers.conversationID) || '';
      searchConversationMessageTotalCount.value = targetResult === null || targetResult === void 0 ? void 0 : targetResult.messageCount;
      if (targetResult) {
        isSearchDetailLoading.value = true;
        setMessageSearchResultListDebounce({
          conversationID: currentSearchConversationID.value
        });
      }
    };
    var generateListItemClass = item => {
      var _item$conversation;
      return currentSearchConversationID.value === (item === null || item === void 0 || (_item$conversation = item.conversation) === null || _item$conversation === void 0 ? void 0 : _item$conversation.conversationID) ? ['list-item', 'list-item-selected'] : ['list-item'];
    };
    var generateResultItemDisplayType = () => {
      if (props.searchType === 'conversation' && currentSearchTabKey.value === 'fileMessage') {
        return 'file';
      } else if (props.searchType === 'conversation' && currentSearchTabKey.value === 'imageMessage') {
        return 'image';
      } else if (isPC) {
        return 'bubble';
      } else {
        return 'info';
      }
    };
    var groupResultListByDate = messageList => {
      var result = [];
      if (!(messageList !== null && messageList !== void 0 && messageList.length)) {
        return result;
      } else if ((messageList === null || messageList === void 0 ? void 0 : messageList.length) === 1) {
        var _messageList$;
        result.push({
          date: generateSearchResultYMD((_messageList$ = messageList[0]) === null || _messageList$ === void 0 ? void 0 : _messageList$.time),
          list: messageList
        });
        return result;
      }
      var prevYMD = '';
      var currYMD = '';
      for (var i = 0; i < (messageList === null || messageList === void 0 ? void 0 : messageList.length); i++) {
        var _messageList$i;
        currYMD = generateSearchResultYMD((_messageList$i = messageList[i]) === null || _messageList$i === void 0 ? void 0 : _messageList$i.time);
        if (prevYMD !== currYMD) {
          result.push({
            date: currYMD,
            list: [messageList[i]]
          });
        } else {
          var _result;
          (_result = result[(result === null || result === void 0 ? void 0 : result.length) - 1]) === null || _result === void 0 || (_result = _result.list) === null || _result === void 0 || _result.push(messageList[i]);
        }
        prevYMD = currYMD;
      }
      return result;
    };
    var navigateToChatPosition = message => {
      if (props.searchType === 'global') {
        // 全局搜索，关闭 search container
        TUIStore.update(StoreName.SEARCH, 'currentSearchingStatus', {
          isSearching: false,
          searchType: props.searchType
        });
        // 切换会话
        TUIConversationService.switchConversation(message === null || message === void 0 ? void 0 : message.conversationID).then(() => {
          TUIStore.update(StoreName.CHAT, 'messageSource', message);
          isUniFrameWork && (TUIGlobal === null || TUIGlobal === void 0 ? void 0 : TUIGlobal.navigateTo({
            url: '/TUIKit/components/TUIChat/index'
          }));
        });
      } else if (props.searchType === 'conversation') {
        // 会话内搜索，关闭 search container
        TUIStore.update(StoreName.SEARCH, 'isShowInConversationSearch', false);
        TUIStore.update(StoreName.CHAT, 'messageSource', message);
        isUniFrameWork && (TUIGlobal === null || TUIGlobal === void 0 ? void 0 : TUIGlobal.navigateBack());
      }
    };
    var generateVueRenderKey = value => {
      return "".concat(currentSearchTabKey, "-").concat(value);
    };
    return (_ctx, _cache) => {
      return _unref(isLoading) ? (_openBlock(), _createBlock(SearchResultLoading, {
        key: 0,
        class: _normalizeClass(['search-result-loading', !_unref(isPC) && 'search-result-loading-h5'])
      }, null, 8, ["class"])) : _unref(isSearchDefaultShow) ? (_openBlock(), _createBlock(SearchResultDefault, {
        key: 1,
        class: _normalizeClass(['search-result-default', !_unref(isPC) && 'search-result-default-h5'])
      }, null, 8, ["class"])) : (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(['tui-search-result', !_unref(isPC) && 'tui-search-result-h5', _unref(isPC) && _unref(isResultDetailShow) && 'tui-search-result-with-border'])
      }, [props.searchType !== 'conversation' && (_unref(isPC) || !_unref(isResultDetailShow)) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchResult), result => {
        return _openBlock(), _createElementBlock("div", {
          key: result.key,
          class: "tui-search-result-list-item"
        }, [props.searchType === 'global' ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(TUITranslateService).t("TUISearch.".concat(result.label))), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.list, item => {
          return _openBlock(), _createElementBlock("div", {
            key: item.conversation.conversationID,
            class: _normalizeClass([generateListItemClass(item)])
          }, [result.key === 'contact' || result.key === 'group' || item.conversation ? (_openBlock(), _createBlock(SearchResultItem, {
            key: 0,
            listItem: item,
            type: result.key,
            displayType: "info",
            keywordList: _unref(keywordList),
            onShowResultDetail: showResultDetail,
            onNavigateToChatPosition: navigateToChatPosition
          }, null, 8, ["listItem", "type", "keywordList"])) : _createCommentVNode("", true)], 2);
        }), 128))]), _unref(currentSearchTabKey) === 'all' || result.cursor ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "more",
          onClick: $event => getMoreResult(result)
        }, [_createVNode(Icon, {
          class: "more-icon",
          file: _unref(searchIcon),
          width: "12px",
          height: "12px"
        }, null, 8, ["file"]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.查看更多")), 1), _createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.".concat(result.label))), 1)])], 8, _hoisted_5)) : _createCommentVNode("", true)]);
      }), 128))])])) : _createCommentVNode("", true), _unref(isResultDetailShow) || props.searchType === 'conversation' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(['tui-search-result-detail', props.searchType === 'conversation' && 'tui-search-result-in-conversation'])
      }, [_unref(isSearchDetailLoading) ? (_openBlock(), _createBlock(SearchResultLoading, {
        key: 0,
        class: _normalizeClass(['search-result-loading', !_unref(isPC) && 'search-result-loading-h5'])
      }, null, 8, ["class"])) : _createCommentVNode("", true), !_unref(isSearchDetailLoading) && _unref(isResultDetailShow) && props.searchType !== 'conversation' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(_unref(searchConversationMessageTotalCount)), 1), _createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.条与")), 1)]), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(keywordList), (keyword, index) => {
        return _openBlock(), _createElementBlock("span", {
          key: index
        }, [_cache[1] || (_cache[1] = _createElementVNode("span", {
          class: "normal"
        }, "\"", -1)), _createElementVNode("span", _hoisted_11, _toDisplayString(keyword), 1), _cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "normal"
        }, "\"", -1))]);
      }), 128))]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.相关的")), 1), _createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.".concat(_unref(currentSearchTabKey) === "allMessage" ? "结果" : _unref(searchMessageTypeList)[_unref(currentSearchTabKey)].label))), 1)])]), _createElementVNode("div", {
        class: "header-enter",
        onClick: _cache[0] || (_cache[0] = $event => _unref(enterConversation)({
          conversationID: _unref(currentSearchConversationID)
        }))
      }, [_createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUISearch.进入聊天")), 1), _createVNode(Icon, {
        class: "enter-icon",
        file: _unref(enterIcon),
        width: "14px",
        height: "14px"
      }, null, 8, ["file"])])])) : _createCommentVNode("", true), !_unref(isSearchDetailLoading) && _unref(searchConversationMessageList) && _unref(searchConversationMessageList)[0] ? (_openBlock(), _createElementBlock("div", _hoisted_13, [props.searchType === 'global' || _unref(currentSearchTabKey) !== 'imageMessage' && _unref(currentSearchTabKey) !== 'fileMessage' ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(_unref(searchConversationMessageList), item => {
        return _openBlock(), _createElementBlock("div", {
          key: generateVueRenderKey(item.ID),
          class: _normalizeClass(['list-item'])
        }, [_createVNode(SearchResultItem, {
          listItem: item,
          listItemContent: item.getMessageContent(),
          type: _unref(currentSearchTabKey),
          displayType: generateResultItemDisplayType(),
          keywordList: _unref(keywordList),
          onShowResultDetail: showResultDetail,
          onNavigateToChatPosition: navigateToChatPosition
        }, null, 8, ["listItem", "listItemContent", "type", "displayType", "keywordList"])]);
      }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(_unref(searchConversationResultGroupByDate), group => {
        return _openBlock(), _createElementBlock("div", {
          key: generateVueRenderKey(group.date),
          class: _normalizeClass(['list-group', _unref(currentSearchTabKey) === 'fileMessage' ? 'list-group-file' : 'list-group-image'])
        }, [_createElementVNode("div", _hoisted_14, _toDisplayString(group.date), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.list, item => {
          return _openBlock(), _createElementBlock("div", {
            key: generateVueRenderKey(item.ID),
            class: _normalizeClass(['list-group-item'])
          }, [_createVNode(SearchResultItem, {
            listItem: item,
            listItemContent: item.getMessageContent(),
            type: _unref(currentSearchTabKey),
            displayType: generateResultItemDisplayType(),
            keywordList: _unref(keywordList),
            onShowResultDetail: showResultDetail,
            onNavigateToChatPosition: navigateToChatPosition
          }, null, 8, ["listItem", "listItemContent", "type", "displayType", "keywordList"])]);
        }), 128))], 2);
      }), 128)), _unref(searchConversationResult) && _unref(searchConversationResult).cursor ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "more",
        onClick: getMoreResultInConversation
      }, [_createVNode(Icon, {
        class: "more-icon",
        file: _unref(searchIcon),
        width: "12px",
        height: "12px"
      }, null, 8, ["file"]), _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(TUITranslateService).t("TUISearch.查看更多历史记录")), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)], 2));
    };
  }
});